import differenceInSeconds from 'date-fns/differenceInSeconds';
import formatRFC3339 from 'date-fns/formatRFC3339';
import fromUnixTime from 'date-fns/fromUnixTime';

import { get_preview_request } from '../../components/assays/V2Assays/conversions';
import keycloakService from '../../keycloak_service';
import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const fetchAssayRunResults = ({
  startTimestamp, endTimestamp, assayConfig = {}, baselineSummary = {}, isAssaysV2Enabled
}) => {
  const startDate = fromUnixTime(startTimestamp);
  const endDate = fromUnixTime(endTimestamp);
  const formattedStartDate = formatRFC3339(startDate)
  const seconds = differenceInSeconds(endDate, startDate);
  const windowWidth = `${seconds} seconds`;

  const modifiedConfig = {
    ...assayConfig,
    baseline: {
      static: baselineSummary,
    },
    window: {
      ...assayConfig.window,
      start: formattedStartDate,
      end: undefined,
      interval: undefined,
      width: windowWidth,
    }
  }

  if (modifiedConfig?.window) {
    modifiedConfig.window.path = assayConfig.getIOPath();
  }

  let body;
  let path;
  /**
   * @deprecated Assays V1 Logic
   */
  if (isAssaysV2Enabled) {
    const formattedStartDateV2 = formatRFC3339(fromUnixTime(startTimestamp));
    const formattedEndDateV2 = formatRFC3339(fromUnixTime(endTimestamp));
    body = JSON.stringify(get_preview_request(assayConfig, baselineSummary, formattedStartDateV2, formattedEndDateV2));
    path = 'v2/api/assays/preview'
  } else {
    body = JSON.stringify(modifiedConfig)
    path = 'v1/api/assays/run_interactive';
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi(path, fetchOptions)
}

export const swrAssayRunRequest = (queryParams) => {
  const [assayConfig, baselineSummary, startTimestamp, endTimestamp, isAssaysV2Enabled] = queryParams;

  return fetchAssayRunResults({
    assayConfig, baselineSummary, startTimestamp, endTimestamp, isAssaysV2Enabled
  })
}

export default fetchAssayRunResults;
